module.exports = __webpack_public_path__ + "static/media/IMG_20191128_145233.0a195a25.jpg";